import React from 'react';
import image from "../assets/images/dermal_page.png";
import image1 from "../assets/images/dermal1.png";
import {Link} from "react-router";
const Dermal = () => {
    return (
        <div>
            <div className={'w-full relative'}>
                <img src={image} alt="" className={'w-full pt-20'}/>
                <div className={'absolute top-0 left-0 w-full h-full bg-black opacity-[17%]'}></div>
                <p className={'absolute md:bottom-20 left-1/4 text-4xl bottom-1  '}>Dermal Filler</p>
                <Link to={'/'}>
                    <div className={'absolute top-24 left-10 '}>
                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.2 29.1199L17.68 22.5999C16.91 21.8299 16.91 20.5699 17.68 19.7999L24.2 13.2799"
                                  stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </svg>

                    </div>
                </Link>
            </div>

            <div className={'py-16 p-5'}>
                <section className="max-w-5xl mx-auto py-16 flex flex-col md:flex-row items-center gap-16  ">
                    <div className="md:w-1/2">
                        <h3 className="text-2xl font-medium mb-3">With Lidocaine</h3>
                        <h3 className="text-2xl font-medium  mb-3">
                            Cross-Linked Hyaluronic acid <br/>
                            Hyaluronic Acid 25 mg/ml
                        </h3>
                        <p className="text-gray-700 text-2xl font-medium leading-relaxed">
                            Makes the skin more youthful
                            High-purity gives consistency with the skin and gives it an excellent effect•
                        </p>
                    </div>
                    <div className="md:w-1/2 relative">
                        <img
                            src={image1}
                            alt="Dermal Filler"
                            className="rounded-lg shadow-md w-full"
                        />
                        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-[7%]"></div>
                    </div>
                </section>

                {/* Next Button */}
                <div className="text-center mt-8">
                    <Link to={'/products/skin-booster'}>
                    <button className="px-6 py-2 border border-black rounded-lg text-black hover:bg-gray-100">
                        Next
                    </button>
                    </Link>
                </div>
            </div>

        </div>
    )
        ;
};

export default Dermal;